@use 'variables' as *;
@use 'mixins' as *;

$-max-width: 20rem;
$-box-shadow: rgb(0 0 0 / 8%) 0 1px 8px 0;
$-shift-padding: 0.25rem; // padding given to the shift() middleware

:host {
  display: contents;
}

:host([hidden]) {
  display: none;
}

.tooltip {
  --cat-font-color-head: #{cat-token('color.ui.font.tooltip', $wrap: false)};
  --cat-font-color-body: #{cat-token('color.ui.font.tooltip', $wrap: false)};
  position: fixed;
  width: max-content;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background-color: cat-token('color.ui.background.tooltip');
  border-radius: cat-border-radius('m');
  color: cat-token('color.ui.font.tooltip');
  transition:
    opacity cat-token('time.transition.m') linear,
    visibility cat-token('time.transition.m') linear;
  visibility: hidden;
  opacity: 0;
  box-shadow: $-box-shadow;
  z-index: cat-z-index('tooltip');
  max-width: min(calc(100vw - 2 * $-shift-padding), $-max-width);

  &-hidden {
    @include cat-visually-hidden;
  }

  &-show {
    opacity: 1;
    visibility: visible;
  }

  p {
    margin: 0;
  }
}

// ----- round

.tooltip-round {
  border-radius: 10rem;
}

// ----- size

.tooltip-s {
  padding: 0.25rem 0.375rem;
  @include cat-body('xs', 500);

  &.tooltip-round {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

.tooltip-m {
  padding: 0.375rem 0.5rem;
  @include cat-body('s', 500);

  &.tooltip-round {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.tooltip-l {
  padding: 0.5rem 0.75rem;
  @include cat-body('m', 500);

  &.tooltip-round {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
